/** 허브 바로머니 일별 매출 엔티티 */
export default class SalesHubBaromoneyDaily {
    /** 아이디 */
    id = 0;
    /** 허브 이름 */
    hubName = '';
    /** 날짜 */
    date = '';
    /** 캐시마감잔액 */
    cacheClosingBalance = 0;
    /** 캐쉬정산합계 */
    cacheSettlementTotal = 0;
    /** 캐쉬충전총액 */
    cacheCharge = 0;
    /** 출금액 */
    withdrawalAmount = 0;
    /** 배송가맹비 */
    deliveryCommission = 0;
    /** 배송대행료 */
    deliveryAmount = 0;
    /** 배송대행료수수료 */
    deliveryAmountCommission = 0;
    /** 주문채널유치수수료 */
    orderChannelCommission = 0;
    /** 공유수수료정산 */
    sharedCommission = 0;
    /** SMS캐쉬차감 */
    smsCacheDeduction = 0;
    /** 기사가상계좌충전금 */
    driverVirtualAccountCharge = 0;
    /** 기사캐쉬마감액 */
    driverCacheClosingBalance = 0;
    /** 예치금마감액 */
    insuranceDeposit = 0;
    /** 고용보험예치금마감액 */
    employmentInsuranceDeposit = 0;
    /** 산재보험예금마감액 */
    occupationalAccidentInsuranceDeposit = 0;
    /** 부가세예치금 */
    vatDeposit = 0;
    /** 가맹점마이너스캐쉬마감액 */
    franchiseeMinusCacheClosingBalance = 0;
    /** 기사캐쉬(플러스)마감액 */
    driverCachePlusClosingBalance = 0;
    /** 출금가능금액마감액 */
    withdrawalAvailableAmount = 0;
    /** 기타 */
    other = 0;
    constructor(_data = {}) {
        Object.assign(this, _data);
    }
}
